module.exports = __webpack_public_path__ + "static/img/010.875a48c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/datav-yongdong/010.png
// module id = QRCW
// module chunks = 1